@import 'styles/mixins';
@import 'styles/variables';

.samlInputError {
  @include ui-sm-text;

  color: $red-50;
  margin-top: 4px;
}

.hidden {
  display: none;
}
